module.exports = __webpack_public_path__ + "media/country_flags/sr-fd25d53e.png";